import React, { HTMLAttributes } from 'react';
import Footer from '../../../components/molecules/footer';
import Header from '../../../components/molecules/header';

interface IHomeCharing { }

type THomeCharingProps = IHomeCharing & HTMLAttributes<HTMLDivElement>;

const HomeCharing :React.FC<THomeCharingProps> = props => {

  const { ...otherProps } = props;

  return (
    <div
      className="flex flex-col min-h-[100dvh] h-full text-white"
      {...otherProps}
    >
      <Header />
      <div className='min-h-[500px] flex items-center justify-center text-3xl font-bold text-center'>
      想獲得你的充電機?
      <br/>
      Coming Soon..
      </div>
      <Footer showConactUsButton={true} />
    </div>
  );
};

export default HomeCharing;